const experiences = [
	{
		title: 'Techlead Power Platform',
		company: 'Malakoff Humanis',
		date: 'Mai 2024 - en cours',
		description: [
			"Conception et développement d'applications Power Apps",
			'Conception et développement de flux Power Automate',
			'Modélisation de bases de données (SharePoint, Dataverse)',
			'Pilotage et gestion de projets IT',
			'Gestion des backlogs',
			'Rédaction des livrables techniques et fonctionnels',
		],
		stack: 'Environnement Microsoft',
		iconBackground: 'green',
	},
	{
		title: 'Ingénieur Power Platform',
		company: 'Devoteam',
		date: 'Janvier 2024 - Mai 2024',
		stack:
			'Environnement Microsoft (Power Platform, Power Apps, Power Automate, Power BI, SharePoint, Office 365)',
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Développeur Power Platform / React.js',
		company: 'Freelance',
		date: 'Juillet 2023 - en cours',
		description: [
			"Accompagnement, conception et développement d'applications web",
			"Conception et développement d'applications Power Apps",
			'Développement de flux Power Automate',
			'Modélisation de bases de données (SQL, NoSQL, SharePoint, Dataverse)',
			"Tests d'intégration",
			'Pilotage et gestion de projets IT',
			'Gestion des backlogs',
			'Rédaction des livrables',
			'Accompagnement, support et formation sur les services Power Platform',
		],
		stack:
			'Environnement Microsoft (Power Platform, Power Apps, Power Automate, Power BI, SharePoint, Office 365), JavaScript, React.js, Node.js avec Express, MySQL',
		clients: 'Avenir Plus, BM Data Solutions',
		iconBackground: 'green',
	},
	{
		title: 'Consultant Microsoft Dynamics 365 / Power Platform',
		company: 'G2i365',
		date: 'Mars 2022 - Décembre 2023',
		description: [
			"Conception et développement d'applications Power Apps",
			'Modélisation de bases de données (SQL, NoSQL, SharePoint, Dataverse)',
			'Développement de flux Power Automate',
			'Rédaction de spécifications techniques et fonctionnelles',
			'Pilotage et gestion de projets',
			'Accompagnement, support et formation sur les services Power Platform',
		],
		stack: 'Environnement Microsoft',
		clients: 'Malakoff Humanis, SNCF, Fonds de dotations du Louvre, Le Bélier',
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title:
			'Consultant Microsoft Dynamics 365 / Power Platform - Développeur Fullstack React / Node.js',
		company: 'Alternance IBM',
		date: 'Mars 2021 - Mars 2022',
		description: [
			"Organisation et stratégie d'entreprise",
			"Développement d'interfaces frontend et backend",
			"Développement d'API REST",
			'Modélisation de bases de données (SQL, NoSQL, SharePoint, Dataverse)',
			"Développement d'applications Power Apps",
			'Développement de flux Power Automate',
			'Paramétrage Dynamics 365 Finance & Operations',
			"Tests d'intégration",
			'Gestion de projet informatique',
			"Développement d'applications desktop",
			"Développement d'applications n-tiers",
			'Méthodologie Scrum',
			'Gestion des backlogs',
		],
		stack:
			'JavaScript, React.js, Node.js avec Express, PHP, Angular, MySQL, MongoDB avec Mongoose, Environnement Microsoft (Power Apps, Power Automate, Power BI, SharePoint)',
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Développeur Front-End React / React Native',
		company: 'Cityviz',
		date: '2020 - 2021',
		description: [
			"Conception et intégration d'interfaces utilisateur",
			'Développement de nouvelles fonctionnalités',
			"Création et évolution d'endpoints API",
			'Assurance qualité (QA) et recette',
			'Maintenance corrective et résolution de bugs',
		],
		stack:
			'React.js, React Native, Redux, Redux-Saga, Python, PostgreSQL, Docker, YouTrack, GitLab',
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Développeur Web et Web Mobile',
		company: 'Étudiant à la Wild Code School',
		date: '2020 - 2021',
		description: [
			"Bootcamp intensif sur le développement web : HTML, CSS, JavaScript, React, Node.js, MySQL, Git, GitHub.",
			"Apprentissage par la pratique via des projets individuels, collectifs et une mission réelle pour un client.",
			"Application des méthodes agiles (Scrum).",
		],
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Manager Opérationnel',
		company: 'Dalkia - Groupe EDF',
		date: '2019 - 2020',
		description: [
			'Management d’une équipe de huit prestataires multi-techniques',
			'Pilotage de projets de rénovation et travaux',
			'Gestion de la relation clients, prestataires et sous-traitants',
			'Suivi des budgets de maintenance',
			'Pilotage de la maintenance via GMAO (GLPI, MAINTA, SAM FM)',
		],
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Responsable Technique',
		company: 'Infoway - Expert en affichage dynamique',
		date: '2018 - 2019',
		description: [
			'Management de projets nationaux (sur site et à distance)',
			'Supervision des déploiements',
			'Coordination entre maîtres d’œuvre, prestataires et développeurs',
			'Paramétrage et configuration d’outils GMAO',
			'Gestion des demandes utilisateurs et support',
			'Pilotage des phases de recette et tests',
			'Administration d’équipements à distance',
		],
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Responsable Technique',
		company: 'Ibis Bercy Village',
		date: '2015 - 2017',
		description: [
			'Membre du comité de direction',
			'Configuration de l’outil GMAO interne (Accor)',
			'Suivi administratif (commandes, contrats, énergies)',
			'Gestion du parc matériel',
			'Pilotage de projets',
			'Gestion de la relation client et résolution de conflits',
		],
		iconBackground: 'rgb(33, 150, 243)',
	},
	{
		title: 'Assistant Responsable Technique',
		company: 'Mercure Paris Centre Tour Eiffel',
		date: '2011 - 2015',
		description: [
			'Management d’une équipe de neuf personnes',
			'Suivi administratif et gestion du matériel',
			'Suivi de projets techniques',
		],
		iconBackground: 'rgb(33, 150, 243)',
		type: 'education',
	},
]

export default experiences
